import { AttributedText, Message } from '@oy/uidesktop';
import { useTranslate } from 'src/hooks';
import { InstantWithdrawalError } from '../InstantWithdrawalError/InstantWithdrawalError';

type WithdrawalAdditionalInputProps = {
  withdrawalOption: { value: string; descriptionKey: string };
  isInstantWithdrawalDisable: boolean;
  isOpeningLessThanClosing: boolean;
  formattedTime: string;
  isUnderMaintenance: boolean;
  bankName: string;
  isNotInService: boolean;
  isExceedInstantWithdrawalLimit: boolean;
};

export const WithdrawalAdditionalInput = (
  props: WithdrawalAdditionalInputProps,
) => {
  const {
    withdrawalOption,
    isInstantWithdrawalDisable,
    isOpeningLessThanClosing,
    formattedTime,
    isUnderMaintenance,
    bankName,
    isNotInService,
    isExceedInstantWithdrawalLimit,
  } = props;
  const { getTranslation } = useTranslate();

  if (withdrawalOption.value === 'manual') {
    return (
      <>
        <AttributedText
          value={getTranslation(withdrawalOption.descriptionKey)}
          textStyle={AttributedText.Style.BodyMdRegular}
        />
        {isUnderMaintenance && (
          <Message type={Message.Type.Warning} showIcon>
            <AttributedText
              value={getTranslation('manualWithdrawal_underMaintenance', {
                bank: bankName,
              })}
              textStyle={AttributedText.Style.BodyMdRegular}
            />
          </Message>
        )}
      </>
    );
  }

  if (!isInstantWithdrawalDisable) {
    return (
      <AttributedText
        value={getTranslation(withdrawalOption.descriptionKey)}
        textStyle={AttributedText.Style.BodyMdRegular}
      />
    );
  }

  if (withdrawalOption.value === 'instant') {
    return (
      <InstantWithdrawalError
        isNotInService={isNotInService}
        isOpeningLessThanClosing={isOpeningLessThanClosing}
        formattedTime={formattedTime}
        isExceedLimit={isExceedInstantWithdrawalLimit}
      />
    );
  }

  return undefined;
};
